export default "__VITE_ASSET__qTkCsTgK__"